const quoteReducer = (state, action) => {
  switch (action.type) {
    case "save":
      const newState = {
        keyState: action.keyState,
        configState: action.configState,
        queryState: action.queryState,
        productState: action.productState,
        configuration: action.configuration,
        custom: action.custom,
      }
      // console.log("QUOTE STATE", newState)

      return newState
    case "remove":
      return state
    case "reset":
      return []
    case "open":
      return {
        // keyState: action.keyState,
        // configState: action.configState,
        // queryState: action.queryState,
        // productState: action.productState,
        configuration: action.configuration,
        order: action.order,
        // custom: action.custom,
      }
    case "quote":
      return { ...state, quote: action.quote }
    case "offer":
      return { ...state, offer: action.offer }
    case "custom-init":
      return { ...state, custom: action.custom }
    case "custom":
      if (
        state.custom &&
        state.custom.find(
          x =>
            x.sku === action.custom.sku &&
            x.index === action.custom.index &&
            x.rate === action.custom.rate
        )
      ) {
        state.custom = state.custom
          .filter(x => {
            if (
              x.index === action.custom.index &&
              x.sku === action.custom.sku &&
              x.rate === action.custom.rate
            )
              return null
            return x
          })
          .filter(Boolean)
        return { ...state, custom: state.custom }
      }

      if (
        state.custom &&
        state.custom.find(
          x => x.sku === action.custom.sku && x.index === action.custom.index
        )
      ) {
        state.custom = state.custom
          .filter(x => {
            if (x.index === action.custom.index && x.sku === action.custom.sku)
              return null
            return x
          })
          .filter(Boolean)
        return { ...state, custom: [...state.custom, action.custom] }
      }

      const custom = state.custom
        ? [...state.custom, action.custom]
        : [action.custom]

      return { ...state, custom: custom }

    default:
      break
  }
}

export default quoteReducer
